import React, { useContext, useEffect, useState } from "react";

//image
import { ReactComponent as CloseSvg } from "../../../assets/admin/close.svg";

import Items from "./Items.jsx";
import PaymentForm from "./PaymentForm.jsx";
import _ from "lodash";
import { Summary } from "./Summary.jsx";
import PaymentSuccess from "./PaymentSuccess.jsx";
import Overlay from "../../Overlay";
import AppContext from "../../../AppContext.jsx";
import { langComponent } from "../../../constants/index.jsx";
import { CART_STEP } from "../../../contexts/CartContext.jsx";
import TenderingDetailContext from "../../../pages/TenderingPage/context.jsx";

const Payment = ({ onClose }) => {
  const { getLang } = useContext(AppContext);
  const TranslationCommon = getLang(langComponent.common);
  const [isSuccess, setIsSuccess] = useState(false);
  const { paymentStep, journal, charge, restartPayment } = useContext(
    TenderingDetailContext
  );

  useEffect(() => {
    return () => {
      restartPayment();
    };
  }, []);

  const handleClose = async () => {
    restartPayment();
    onClose();
  };

  const getContentRender = () => {
    if (paymentStep === CART_STEP.PAYMENT) {
      return <PaymentForm />;
    }

    return <Items />;
  };

  useEffect(() => {
    if (!charge && !journal) return;

    if (charge?.status === "successful" || journal?.status === 2) {
      setIsSuccess(true);
    }
  }, [charge, journal]);

  if (isSuccess) {
    return <PaymentSuccess onClose={handleClose} />;
  }

  return (
    <>
      <Overlay
        onClose={handleClose}
        style={{
          alignItems: "flex-start",
        }}
      >
        <div className="tendering-cart">
          <div className="tendering-cart-close" onClick={handleClose}>
            <CloseSvg />
            {TranslationCommon("Close")}
          </div>
          <div className="tendering-cart-content">
            {getContentRender()}
            <Summary />
          </div>
        </div>
      </Overlay>
    </>
  );
};

Payment.propTypes = {};

export default Payment;
